'use strict'

const React = require('react')
const createReactClass = require('create-react-class')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const LocationDropDown = require('../../../../shared/_layouts/_templates/_includes/engines/location-dropdown.jsx')
const RoomSelect = require('./rooms-dropdown.jsx')
const SearchButton = require('./searchButton.jsx')
const EngineHelper = require('../../../../shared/_layouts/_templates/_includes/engines/engineHelper.js')
const DateHelper = require('../../../../_plugins/lib/dateHelper.js')
const Helpers = require('../../../../_plugins/lib/helpers.js')
const HiddenInputs = require('../../../../shared/_layouts/_templates/_includes/engines/hiddenInputs.jsx')
const { string, object } = PropTypes

const HotelsEngine = createReactClass({
  mixins: [EngineHelper, Helpers],

  rememberChoicesCookieNames: {
    showSecondRoom: 'engineHrzntl_ho_secondRoomShow',
    showDepartDate: 'engineHrzntl_hcp_departDateShow'
  },

  propTypes: {
    Location: string,
    domainSettings: object,
    agentSettings: object,
    formSettings: object,
    ArrivalDate: PropTypes.instanceOf(Date),
    DepartDate: PropTypes.instanceOf(Date),
    engineSearchField: string,
    hiddenLocation: string,
    agentData: object,
    selected: string,
    locations: object,
    roomTypeSelected: string,
    RoomTypes: object.isRequired,
    pageData: object,
    labels: object.isRequired,
    terminal: string
  },

  getInitialState () {
    return {
      hiddenInputs: {},
      showSecondRoom: this.getCookie(this.rememberChoicesCookieNames.showSecondRoom) === '1',
      showDepartDate: this.getCookie(this.rememberChoicesCookieNames.showDepartDate) === '1'
    }
  },

  getDefaultProps () {
    return {
      hiddenLocation: '',
      engineSearchField: '',
      ArrivalDate: DateHelper.alterDateByNumberOfDays(new Date(), 1),
      DepartDate: DateHelper.alterDateByNumberOfDays(new Date(), 9),
      selected: 'ho',
      terminal: ''
    }
  },

  componentDidMount () {
    this.getHiddenInputs()
  },

  setNumberOfRooms (e) {
    e.preventDefault()
    const { target } = e
    if (target.value && target.value.length) return // This is an actual room!
    const showSecondRoom = target.tagName !== 'SELECT'
    this.setCookie(this.rememberChoicesCookieNames.showSecondRoom, (showSecondRoom ? 1 : 0))
    this.setState({
      showSecondRoom
    })
  },

  showHideDepartDate ({ target }) {
    const showOrHide = target.value === 'yes_please_need_airport_parking'
    this.setCookie(this.rememberChoicesCookieNames.showDepartDate, (showOrHide ? 1 : 0))
    this.setState({
      showDepartDate: showOrHide
    })
  },

  render () {
    const {
      Location,
      pageData: { pageName },
      domainSettings,
      ArrivalDate,
      DepartDate,
      engineSearchField,
      hiddenLocation,
      agentData,
      selected,
      locations,
      formSettings,
      roomTypeSelected,
      RoomTypes,
      labels,
      terminal
    } = this.props
    const defaultRoomType = roomTypeSelected || formSettings.defaultRoomType
    const pagesName = pageName !== 'index' ? pageName + '.html' : ''
    const { hiddenInputs, showSecondRoom, showDepartDate } = this.state
    const activeRoom = formSettings.defaultRoomType
    const { agent, typeRID, groupCode } = agentData
    const arrivalDate = DateHelper.formatDateToDMY(ArrivalDate)
    const departDate = DateHelper.formatDateToDMY(DepartDate)
    const arrivalDateFormatted = DateHelper.formatDateToDddMMyy(ArrivalDate)
    const departDateFormatted = DateHelper.formatDateToDddMMyy(DepartDate)
    let arrivalDateText = labels.startDateHomepageTest
    let departDateText = labels.endDateHomepageTest
    if (pageName !== 'index') {
      arrivalDateText = 'Hotel ' + labels.startDateHomepageTest.toLowerCase()
    }

    const activeClass = classNames({
      'hidden': selected !== 'ho',
      'hiddenLocation': hiddenLocation
    })

    const showSecondRoomClass = classNames({
      'hidden': showSecondRoom,
      'pull-right': true,
      'small': true
    })

    const defaultInputs = {
      agentgroup: groupCode,
      channel: typeRID,
      agent: agent,
      product: 'hcp',
      selectProduct: 'ho',
      request: '21',
      Nights: '1',
      Referer: 'http://' + domainSettings.domain + '/' + (pagesName || ''),
      domain: domainSettings.domain,
      lang: 'en',
      rule_set: formSettings.ruleset
    }

    const returnDateClass = classNames({
      'form-group': true,
      'top-margin': true,
      'top-padding': true,
      'hidden': !showDepartDate
    })

    let roomOneLabel = showSecondRoom ? 'Room 1' : 'Room Type'
    roomOneLabel = 'Staying in'

    return (
      <div className={activeClass}>
        <form id='hotelEngine' acceptCharset='UTF-8' action={formSettings.hotelAction} className='panel panel-default' method={formSettings.method}>

          <div className='panel-body'>
            <div className='row'>

              { !hiddenLocation
                ? <div className='form-group airport'>
                  <label>Flying from</label>
                  <LocationDropDown activeLocation={Location || formSettings.defaultHotelLocation} locations={locations.hotels} />
                </div>
              : <input name='Location' type='hidden' className='l' value={hiddenLocation} data-track-name='location' />
              }

              <div className='form-group room no-margin'>
                <label>{ roomOneLabel }</label>
                <RoomSelect name='RoomType[0]' RoomTypes={RoomTypes} activeRoom={defaultRoomType} />
                <a href='#' data-hxtrack-name='engine-ho-add-another-room' className={showSecondRoomClass} onClick={this.setNumberOfRooms}>Add another room</a>
                { showSecondRoom && (
                  <div className='form-group'>
                    <label>Room 2</label>
                    <RoomSelect name='RoomType[1]' RoomTypes={RoomTypes} activeRoom={activeRoom} secondRoom changeCallback={this.setNumberOfRooms} />
                  </div>
                )}
              </div>

              <div className='form-group onlyDate no-margin'>
                <label>{ arrivalDateText }</label>
                <input className='alternateDA form-control hxtrack' defaultValue={arrivalDateFormatted} readOnly />
                <input className='dA' name='ArrivalDate' defaultValue={arrivalDate} type='hidden' />
                <div />
              </div>

              <div className='form-group onlyDate top-margin'>
                <label>Include<span className='hidden-sm'> airport</span> parking</label>
                <select className='form-control' name='getting_to_airport' data-track-name='getting_to_airport' defaultValue='please_select' onChange={this.showHideDepartDate}>
                  <option value='please_select'>Please select</option>
                  <option value='yes_please_need_airport_parking'>Yes please</option>
                  <option value='no_thanks'>No thanks</option>
                </select>
                <div className={returnDateClass}>
                  <label>{ departDateText }</label>
                  <input className='alternateDD form-control hxtrack' defaultValue={departDateFormatted} />
                  <input className='dD' name='DepartDate' defaultValue={departDate} type='hidden' />
                </div>
              </div>
              
            <SearchButton agent={agent} />
            </div>
          </div>

          <HiddenInputs inputs={defaultInputs} />
          { engineSearchField && (
            <input name='search' type='hidden' value={engineSearchField} />
          )}
          { terminal.length > 0 && (
            <input name='terminal' type='hidden' value={terminal} />
          )}
          <HiddenInputs inputs={hiddenInputs} />
        </form>

      </div>
    )
  }
})

module.exports = HotelsEngine



// WEBPACK FOOTER //
// ./_layouts/_templates/_includes/engine-horizontal/hotels-engine.jsx